// returns the financial year for the given date, e.g. provided:2022 returns 2021-07-01 && 2022-06-30
// Both are the *local midnight* of their day, and the backend treats endDate as
// inclusive of the whole day it names (see createCTFilters and
// getAccountReportHoldingsDetails) - don't "fix" endDate to 23:59 here, that would
// pull the following day's transactions into the report.
export const getFinancialYearDates = (year: number) => {
  const startDate = new Date(year - 1, 6, 1); // July 1st of the previous calendar year
  const endDate = new Date(year, 5, 30); // June 30th of the given year

  return { startDate: startDate.getTime(), endDate: endDate.getTime() };
};
// changes MM/DD/YYYY to DD/MM/YYYY
export const transformDateFormat = (dateString: string) => {
  const [month, day, year] = dateString.split(" ")[0].split("/");
  const time = dateString.split(" ")[1] + " " + dateString.split(" ")[2];
  return `${day}/${month}/${year} ${time}`;
};

// Function to recursively transform date formats in any object
export const transformDatesInObject = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map((item) => transformDatesInObject(item));
  } else if (typeof obj === "object" && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      if (key === "date" && typeof obj[key] === "string") {
        acc[key] = transformDateFormat(obj[key]);
      } else {
        acc[key] = transformDatesInObject(obj[key]);
      }
      return acc;
    }, {} as any);
  } else {
    return obj;
  }
};

// change the provided name into a business friendly name, e.g. "businessName" -> "Business Name"
export const formatBusinessFriendlyName = (name: string) => {
  return (
    name
      // Insert a space before all caps
      .replace(/([A-Z])/g, " $1")
      // Capitalize the first letter of each word
      .replace(/^./, (char: string) => char.toUpperCase())
      .trim()
  );
};

// sort the array of objects by date field
export const sortArrayByDate = (array: any[]): any[] => {
  return array.sort((a, b) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });
};

// Function to recursively sort all arrays in an object by date
export const sortAllArraysByDate = (obj: any): any => {
  if (Array.isArray(obj)) {
    // Sort the array by date
    return sortArrayByDate(obj.map((item) => sortAllArraysByDate(item)));
  } else if (typeof obj === "object" && obj !== null) {
    const transformedObj = Object.keys(obj).reduce((acc, key) => {
      acc[key] = sortAllArraysByDate(obj[key]);
      return acc;
    }, {} as any);
    return transformedObj;
  } else {
    return obj;
  }
};
// accepts timestamp and returns date in format DD/MM/YYYY
export const formatTimestampToDate = (timestamp: number | undefined): string | undefined => {
  if (timestamp === undefined) {
    return undefined; // or handle this case as needed
  }
  const date = new Date(timestamp);
  const options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "long", year: "numeric" };
  return date.toLocaleDateString("en-GB", options).replace(",", "");
};

export const disclaimerMessageEOFY =
  "Disclaimer:\n\nYou understand and acknowledge that the content of this document reflects order(s) placed\nby you and transaction(s) executed for you. This document does not constitute any financial,\ninvestment, legal, tax or any other advice. This document is available to you on an ‘as-is’ basis\nonly, and Caleb & Brown is not liable for your amendment(s) to this document after export.\n\nPlease contact us at support@calebandbrown.com if you require a summary older than Aug 2020.\n\nNote that, only completed transactions will be included in the report.";
